module.exports = __webpack_public_path__ + "static/media/heart.dfcab039.svg";